/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkingSpaceType = {
    Standard: 'Standard'
} as const;
export type ParkingSpaceType = typeof ParkingSpaceType[keyof typeof ParkingSpaceType];

